import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from 'src/app/models/user.model';

@Component({
    selector: 'app-confirm-deactivate-user-dialog',
    template: `
    <mat-dialog-content>
      <p class="py-6 text-center">
        Please confirm if you'd like to remove
        <span class="font-semibold underline">{{ data.Name }}</span
        >.
      </p>
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="flex justify-center w-full gap-2">
        <button
          class="flex items-center bg-gray-100 hover:bg-gray-300 px-4 py-2 rounded-lg shadow-sm"
          mat-dialog-close
        >
          Cancel
        </button>
        <button
          class="flex items-center text-white bg-orange-600 hover:bg-orange-500 px-4 py-2 rounded-lg shadow-sm"
          (click)="onConfirm()"
          cdkFocusInitial
        >
          Confirm
        </button>
      </div>
    </mat-dialog-actions>
  `,
    imports: [MatDialogModule, MatButtonModule]
})
export class ConfirmDeactivateUserDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDeactivateUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: Partial<User>,
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
